// src/i18n.js
import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
  zh: {
    home: {
      h1: "日中国际教育交流协会",
      h2: "协会概要",
      h3: "事业介绍",
      h4: "企业实绩",
      h5: "问询页面",
      h6: "互动业务介绍",
      h7: "协会概要",
      h8: "团体名称",
      h9: "日中国际教育交流协会",
      h10: "英文:Japan-China Educational Exchange Association",
      h11: "所在地",
      h12: "联系方式",
      h13: "邮编：181-0013东京都三鹰市下连雀7-13-9三鹰shinpar克斯",
      h14: "海外抛点",
      h15: "中国上海、昆明、重庆",
      h16: "※与当地事务所或人才派遣机构合作，开展本协会的窗口业务",
      h17: "E- MAIL",
      h18: "Jcea_info@yeah.net",
      h19: "接受企业实绩",
      h20: "温泉酒店",
      h21: "滑雪场",
      h22: "免税店",

      h23: "日中国际教育交流协会",
      h24: "TOP",
      h25: "协会概要",
      h26: "事业介绍",
      h27: "企业实绩",
      h28: "问询页面",
      h29: "@日中国际教育交流协会 Al Rights Reservcd 日lCP备19044258号25 日B2-20191025",
    },
    gai: {
      g1: "日中国际教育交流协会始终秉持着推动中日两国教育深度交融、共同进步的崇高使命，致力于全方位促进中日教育交流。在高等教育领域，协会积极发挥桥梁与纽带作用，全力推动中日高校间多层次、多维度的校际教育交流与合作。通过组织各类学术研讨会、教师互访项目、学生交换计划等丰富多样的活动，为两国高校搭建起知识共享、理念碰撞的广阔平台，促进教育资源的优化配置与优势互补，进而提升双方的教育质量与学术水乎。",
      g2: "同时，协会高度重视实践能力的培养与职业发展的衔接，精心搭建起中国高校学生赴日实习、研修、就职的综合性平台。通过与日本众多知名企业、研究机构建立紧密合作关系，为中国学生提供丰富的实习与就业机会，让他们在真实的工作环境中积累宝贵经验，提升专业技能，深入了解日本的职场文化与行业动态，为未来的职业发展奠定坚实基础。在此过程中，学生们不仅能够锻炼自身的专业能力，还能在跨文化的环境中不断磨砺，逐渐成长为具有全球视野、跨文化沟通能力的优秀人才。",
    },
    jie: {
      j1: "中国大学生赴日实习项目是日本法务省为推进国际教育文化交流，面向海外高校在校生推出的赴日短期实习实践项目。社会实践是中国高等教育的重要组成部分，实践教育也符合国家高等素质教育的需要。在教育国际化的背景下，跨文化社会实践已成为国际化人才培养的创新形式。根据《教育部等部门关于进一步加强高校实践育人工作的若干意见》的有关要求，各高校相继将实践育人工作置于人才培养的重要位置，纳入学校教育规划，系统设计教育体系。四、实践并规定了相应的时间单位。",
      j2: "响应教育部号召，为满足各高校及日语专业学生的实际需求，增进中日两国教育界的友好交流，与日本法务省指定的日本社会实践支援机构及企业合作，开展周期2至12个月的日企合作活动。开展就业实践项目，同时也致力于学生毕业后的就业介绍。",
      j3: "大学生通过亲身实践，学习日本企业先进的管理模式和服务理念，了解企业的运营模式、工作方式和人际关系，不仅能使中国大学生短期内提高日语水平，还能毕业。它还有助于学习就业技能，积累职场经验，为进入社会打好基础，更有计划地规划人生。",
    },
  },
  ja: {
    home: {
      h1: "日中国際教育交流協会です",
      h2: "協会概要",
      h3: "事業紹介",
      h4: "受け入れ事業実績",
      h5: "お問い合わせ",
      h6: "インタ-ンシップ事業紹介",
      h7: "協会概要",
      h8: "団体名",
      h9: "日中国際教育交流協会", // 假设这是该组织的日语官方名称
      h10: "英文:Japan-China International Educational Exchange Association",
      h11: "所在地",
      h12: "連絡先",
      h13: "〒181-0013 東京都三鷹市下連雀7-13-9三鷹シャインパークス",
      h14: "海外拠点",
      h15: "中国・上海、昆明、重慶",
      h16: "※現地事務所又は人材送出し機関と提携し当協会の窓口業務を展開",
      h17: "E-MAIL",
      h18: "jcieea_info@yeah.net",
      h19: "受け入れ事業実績",
      h20: "温泉ホテル",
      h21: "スキ一場",
      h22: "免税店",

      h23: "日中国際教育交流協会",
      h24: "TOP",
      h25: "協会概要",
      h26: "事業紹介",
      h27: "受け入れ事業実績",
      h28: "お問い合わせ",
      h29: "@日中国際教育交流協会 Al Rights Reservcd 日lCP备19044258号25 日B2-20191025",
    },
    gai: {
      g1: "日中国際教育交流協会は、中日両国の教育の深い融合を推進し、共に進歩するという崇高な使命を持ち、全方位的な中日教育交流の促進に努めています。高等教育分野において、協会は積極的に架け橋と絆の役割を発揮し、中日大学間の多層的、多次元的な学校間教育交流と協力を全力で推進していきます。各種学術シンポジウム、教員相互訪問プロジェクト、学生交換プログラムなどの多彩な活働を通じて、両国の大学のために知識の共有、理念の衝突の広いプラットフォームを構築し、教育資源の最適な配置と相互補完を促進し、双方の教育の質と学術の質を向上させます。",
      g2: "また、協会は実践能力の育成と職業発展の連携を非常に重視し、中国の高校生の日本での実習、研修、就職の総合的なプラットフォームを入念に構築しています。日本の多くの有名企業、研究机関と緊密な協力関系を結び、中国の学生に豊富なインターンシップと就業机会を提供し、彼らにリアルな職場環境で貴重な経験を積ませ、専門技能を向上させ、日本の職場文化と業界の働向を深く理解させ、将来の職業発展のために強固な基礎を築きます。その過程で、学生たちは自らの専門能力を磨くだけでなく、異文化の環境でも磨きをかけ、グローバルな視野や異文化コミュニケーション能力を備えた優秀な人材へと成長していきます。",
    },
    jie: {
      j1: "中国大学生の日本でのインターンシッププロジェクトは、日本法務省が国際教育文化交流を推進するために海外の大学在学生に向けて、打ち出した日本への短期インターンシップ実践プロジェクトである。社会実践は中国の高等教育の重要な構成部分でもあり、実践教育は国家の高等素質教育の需要にも合致している。教育の国際化を背景に、異文化社会の実践はすでに国際化人材育成の革新的な形式となっている。「教育部などの部門の大学実践育人活動の更なる強化に関するいくつかの意見」の関連要求に基づき、各大学は相次いで実践育人活動を人材育成の重要な位置に置き、学校教育計画に組み入れ、教育システムを系統的に設計し、実践し、相応の時間単位を規定しました。",
      j2: "教育部の呼びかけに応じ、各大学及び日本語専門学生の実際の需要を満たし、中日両国の教育界の友好交流を増進するため、日本法務省が指定した日本社会実践支援機構及び企業と協力し、周期２か月から１２か月の日本企業実践プロジェクトを展開し、同時に学生が卒業後の就職先紹介にも力入れています。",
      j3: "大学の学生は職場での親身的な実践を通じて、日本企業の先進的な管理モデルとサービス理念を学び、企業の運営モデル、働き方、人間関係を理解することは、中国大学生が短期的に日本語のレベルを高めるだけでなく、卒業後に就職するための技能を身につけ、職場体験を蓄積し、社会進出のための土台を作り、人生設計をより計画的に定めるのにも役立ちます。",
    },
  },
};

export default new VueI18n({
  locale: "ja", // 设置默认语言为中文
  messages,
});
